module.exports = __webpack_public_path__ + "static/media/elefante_big.77ff193c.png";